import React from 'react'
import './contact.css'

const Contact = () => {
  return (
    <>
    <>
  <h1 style={{textAlign:'center',backgroundColor:'green'}}>Contact Us</h1>
  <div className="containerb">
    <form action="#" method="post">
      <label className='labelb' htmlFor="name">Name</label>
      <input
        className='inputb'
        type="text"
        id="name"
        name="name"
        placeholder="Your name.."
        required=""
      />
      <label htmlFor="email">Email</label>
      <input
        className='inputb'
        type="text"
        id="email"
        name="email"
        placeholder="Your email.."
        required=""
      />
      <label className='labelb' htmlFor="subject">Subject</label>
      <select className='selectb' id="subject" name="subject" required="">
        <option value="">Select subject..</option>
        <option value="General Enquiry">General Enquiry</option>
        <option value="Technical Issue">Technical Issue</option>
        <option value="Feedback">Feedback</option>
      </select>
      <label className='labelb' htmlFor="message">Message</label>
      <textarea
        className='textareab'
        id="message"
        name="message"
        placeholder="Write your message here.."
        style={{ height: 200 }}
        required=""
        defaultValue={""}
      />
      <button className='buttonb' type="submit">Submit</button>
    </form>
  </div>
</>

    
    </>
  )
}

export default Contact